import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { InventoryService } from '../../services/inventory.service';
import { StorageService } from 'src/app/services/storage.service';
import { BaseService } from 'src/app/services/base.service';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { PrinterModel } from 'src/app/models/printer.model';
import { SelectItemModal } from '../select-item/select-item.modal';
import { BasePage } from 'src/app/base.page';
import { KioskService } from 'src/app/services/kiosk.service';
import { UserProfileModel } from 'src/app/models/user-profile.model';
import { IdleTimerService } from 'src/app/services';

@Component({
	selector: 'app-confirm-kiosk-mode',
	templateUrl: './confirm-kiosk-mode.modal.html',
	styleUrls: ['./confirm-kiosk-mode.modal.scss'],
})
export class ConfirmKioskModeModal {
	title = 'Navigate to Kiosk Mode?';
	selectedPrinter = StorageService.lastUsedCachedPrinter;
	faChevronRight = faChevronRight;
	printerSelectOpen = false;

	constructor(
		public inventoryService: InventoryService,
		public kioskService: KioskService,
		public idleTimerService: IdleTimerService,
		private modalCtrl: ModalController,
		private base: BaseService,
	) {}

	async back() {
		await this.modalCtrl.dismiss();
	}

	public async initializeKioskSystemUser() {
		try {
			StorageService.isKioskMode = true;
			StorageService.authToken = await this.kioskService.getKioskSystemUserToken();
			const selectedKioskPrinter = StorageService.lastUsedCachedPrinter;
			await this.base.authService.setUserProfile({ isAdminPortal: false, isSystemUser: true,
				getSystemUserProfile:  (): Promise<UserProfileModel> => {
					return this.kioskService.getKioskSystemUserProfile(selectedKioskPrinter.id)
				}
			});
			StorageService.saveTenant(StorageService.user.authorizedTenants[0]);
			await this.idleTimerService.toggleIdleTimer(true);
			console.log("Kiosk auth initialized.");
			return true;
		 } catch(e){
			console.error('Error: Could not initialize kiosk - aborting. ', e);
			return false;
		 }

	}

	async proceed() {
		this.modalCtrl.dismiss();
		StorageService.isMenuOpen = false;

		const isInitialized = await this.initializeKioskSystemUser();
		if(isInitialized) await this.base.navigateRoot('/kiosk-start');

	}

	async handleSelectPrinterPress() {
		if (this.printerSelectOpen) return;
		this.printerSelectOpen = true;
		const modal = await this.base.modalCtrl.create({
			component: SelectItemModal,
			componentProps: {
				title: 'Select Printer',
				items: StorageService.printers,
				searchProperties: {
					title: 'name',
					subtitle: '',
					endText: '',
				},
			},
			cssClass: 'fullscreen-modal',
		});

		modal.onDidDismiss().then(async (data) => {
			const selectedPrinter: PrinterModel = data?.data;
			if (selectedPrinter) {
				this.base.authService.updateUserProfile({
					currentPrinterId: selectedPrinter.id,
				});

				StorageService.lastUsedCachedPrinter = selectedPrinter;
				this.selectedPrinter = selectedPrinter;
			}
			this.printerSelectOpen = false;
		});

		return await modal.present();
	}
}
